export const USD_PER_CREDIT = 0.01;

export const AI_CREDITS_EXHAUSTED = 'ai_credits_exhausted';
